import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { SafeHtmlPipe } from '@web/common';

@Component({
  selector: 'app-summernote-html-preview',
  imports: [SafeHtmlPipe],
  templateUrl: './summernote-html-preview.component.html',
  styleUrl: './summernote-html-preview.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SummernoteHtmlPreviewComponent {
  public readonly html = input.required<string>();
}
